/**
 * Don't need an actual reducer and all that stuff -- just need actions that I can use
 * so that I can easily communicate with the worker within the application
 * const foo = createAction('worker/foo') --> HOC that returns a redux action with type worker/foo
 * https://redux-toolkit.js.org/api/createAction
 */
import { createAction } from '@reduxjs/toolkit';
import { FileDetails } from '../../Uploader/context';

export type EventPayload = { userColumns: BulkUploaderColumn[]; file: any };
export type ProcessEventPayload = EventPayload & { chunkSize: number };
const loaded = createAction('worker/load');
const parsing = createAction('worker/parsing');
const missingColumns = createAction<string>('worker/missing-columns');

const success = createAction<{ workSheet: any[]; fileDetails: Partial<FileDetails> }>('worker/success');

const validateHeaders = createAction<EventPayload>('worker/validateHeaders');
const processFile = createAction<ProcessEventPayload>('worker/process-file');

export { loaded, parsing, missingColumns, success, validateHeaders, processFile };
